import { DatePipe } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { switchMap, takeUntil, tap } from 'rxjs/operators';
import { ProgramLocation } from 'src/app/models/client/client-program.interface';
import { ClientDataResponse } from 'src/app/models/client/client.interface';
import { ClientService } from 'src/app/services/client.service';
import { ProgramService } from 'src/app/services/program.service';

@Component({
  selector: 'app-client-employee-detail',
  templateUrl: './client-employee-detail.component.html',
  styleUrls: ['./client-employee-detail.component.scss']
})
export class ClientEmployeeDetailComponent implements OnInit, OnDestroy {
  activeTab = 'Overview';
  pageTabs = [
    'Overview',
    'Permission',
    'License',
    'Wage List',
    'Agenda',
    'Notification',
    'Action History',
  ];
  generalInfo = false;
  addressInfo = false;
  instructionNotesInfo = false;
  quickLinkToggle = false;
  creditBalanceToggle = false;
  private unsubscribe$ = new Subject<void>();
  serverDateFormat = 'yyyy-MM-dd';
  quickLinks = [
    {
      name:'All Cases',
      link:'javascript:void(0)'
    },
    {
      name:'Open Cases',
      link:'javascript:void(0)'
    },
    {
      name:'Closed Cases',
      link:'javascript:void(0)'
    },
    {
      name:'All Invoices',
      link:'javascript:void(0)'
    },
    {
      name:'Unpaid Invoices',
      link:'javascript:void(0)'
    },
    {
      name:'Payment Histories',
      link:'javascript:void(0)'
    }
  ]

  creditBalances = [
    {
      name:"Outstanding",
      value:0
    },
    {
      name:"Past Due",
      value:0
    },
    {
      name:"Time Management",
      value:0
    }
  ]
  programLocationData: ProgramLocation;
  @BlockUI('program-location-details') clientProgramLocationBlockUI: NgBlockUI;
  programContactLocationForm :FormGroup;
  @BlockUI('program-location-contacts-ui') programLocationContactsBlockUI: NgBlockUI;
  programLocationContactTotal: number;
  programLocationContacts: any[];
  programLocationContactPage =1;
  programLocationContactLimit: number = 20;
  permissions = [
    'edit cases',
    'create cases',
    'view cases',
    'download',
    'view dashboard',
    'upload',
    'view files'
  ]


  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private clientService: ClientService,
    private fb: FormBuilder,
    private _datePipe: DatePipe,
    private toastr: ToastrService,
    private router: Router,
    private programService:ProgramService
  ) {
  }

  ngOnInit() {
    this.clientProgramLocationBlockUI.start();
    this.route.params
      .pipe(
        takeUntil(this.unsubscribe$),
        switchMap((params: Params) => this.fetchClientProgramDetails(params.id))
      )
      .subscribe(()=>{
        this.clientProgramLocationBlockUI.stop();
      });

      this.initProgramContactLocationForm();
      this.getProgramLocationContacts();
  }

  initProgramContactLocationForm(){
    this.programContactLocationForm = this.fb.group({
      role: ['',[Validators.required]],
      program_location: [0,[Validators.required]],
      client_contact: [0,[Validators.required]],
    });
  }

  fetchClientProgramDetails(id: number) {
    return this.programService.getClientProgramLocations(id).pipe(
      takeUntil(this.unsubscribe$),
      tap(({ details }: ClientDataResponse<ProgramLocation>) => {
        this.programLocationData = details;
      })
    );
  }

  public openPopup(content, size = 'md') {
    this.modalService.open(content, {
      ariaDescribedBy: 'modal-basic-title',
      windowClass: 'groupModal',
      size,
      centered: true,
    });
  }

  getProgramLocationContacts() {
    this.programLocationContactsBlockUI.start();
    this.programService.getProgramContacts(this.programLocationContactLimit, this.programLocationContactPage).pipe(takeUntil(this.unsubscribe$)).subscribe(
      (resp) => {
        const { hits, offset, estimatedTotalHits } = resp.details;
        this.programLocationContacts = hits;
        this.programLocationContactTotal = estimatedTotalHits;
        this.programLocationContactsBlockUI.stop();
      },
      (error) => {
        this.programLocationContactsBlockUI.stop();
      }
    );
  }

  onPageChangeProgramLocationContacts(event: any) {
    this.programLocationContactPage = event;
    this.getProgramLocationContacts();
  }

  onSizeChangeProgramLocationContacts(limit: number) {
    this.programLocationContactLimit = limit;
    this.programLocationContactPage = 1;
    this.getProgramLocationContacts();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
